import React from "react";
import OperationWay from "components/comp/OperationWay";
import OperationWayOp from "components/comp/OperationWayOp";
import OperationStrategy from "components/comp/OperationStrategy";
import OperationApp from "components/comp/OperationApp";
import SubPicture from "components/comp/SubPicture";
import laptopImg from "assets/images/laptop.jpg"

// why: 핵심역량 하위 메뉴 통합 페이지(유지보수)

const CompMaintenance = () => {
  return (
    <main className="page-sub">
      <section className="company-main">
      <SubPicture img={laptopImg}/>
        <OperationWay/>
        <OperationWayOp/>
        <OperationStrategy/>
        <OperationApp/>
      </section>
    </main>
  );
};

export default CompMaintenance;


